// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2wxHA","resendInfoText":"OnGoingPaymentBox_resendInfoText__3APB1"};